import { createElement } from 'react';
import { useNCTextLocalizer } from '../../locale/useNCTextLocalizer';
import { ZeroState, ZeroStateProps } from '../ZeroState';
import { postfixTestId, TestIdProps } from '../../util/testId';
import cx from 'classnames';
import cn from './TableZeroState.css.json';
import './TableZeroState.css';

export type TableZeroStateVariant = 'hiddenColumns' | 'noData';

export interface TableZeroStateProps extends TestIdProps {
  height?: number;
  width?: number;
  headerHeight: number;
  variant?: TableZeroStateVariant;
  customProps?: ZeroStateProps;
  customNoColumnProps?: ZeroStateProps | string;
  onManageColumns?: () => void;
  className?: string | null;
  columnHeadersVisible?: boolean;
  disabled?: boolean;
}

export const TableZeroState = (props: TableZeroStateProps) => {
  const localize = useNCTextLocalizer('Table');

  const showHeaderDivider = props.headerHeight > 0;
  // When showing header divier, - 1 to make sure it overlaps with original header bottom border
  const headerHeight = showHeaderDivider ? props.headerHeight - 1 : props.headerHeight;
  // Assume there is always a scrollbar if there are headers
  const hbarHeight = showHeaderDivider && props.columnHeadersVisible !== false ? 12 : 0;
  const zeroStateDivTestId = props.testId ? postfixTestId(props.testId, 'div') : undefined;
  const zeroStateButtonTestId = props.testId ? postfixTestId(props.testId, 'button') : undefined;
  let zeroStateContent = (
    <ZeroState text={localize('noItems.msg')} testId={props.testId} disabled={props.disabled} />
  );
  if (props.customProps && props.variant === 'noData') {
    zeroStateContent = (
      <ZeroState {...props.customProps} testId={props.testId} disabled={props.disabled} />
    );
  } else if (props.customNoColumnProps && props.variant !== 'noData') {
    if (typeof props.customNoColumnProps === 'string') {
      zeroStateContent = (
        <ZeroState
          text={props.customNoColumnProps}
          testId={props.testId}
          disabled={props.disabled}
          actionButtonOneProps={{
            testId: zeroStateButtonTestId,
            text: localize('manageColumns.button.label'),
            onPress: props.onManageColumns,
          }}
        />
      );
    } else
      zeroStateContent = (
        <ZeroState {...props.customNoColumnProps} testId={props.testId} disabled={props.disabled} />
      );
  } else if (props.variant !== 'noData') {
    zeroStateContent = (
      <ZeroState
        text={localize('allColumnsHidden.msg')}
        testId={props.testId}
        disabled={props.disabled}
        actionButtonOneProps={{
          testId: zeroStateButtonTestId,
          text: localize('manageColumns.button.label'),
          onPress: props.onManageColumns,
        }}
      />
    );
  }

  return (
    <div
      data-testid={zeroStateDivTestId}
      className={cx(
        cn.container,
        props.className,
        showHeaderDivider && props.columnHeadersVisible !== false && cn.showHeaderDivider
      )}
      style={{
        width: props.width,
        height: `calc(100% - ${headerHeight}px - ${hbarHeight}px)`,
        marginBlockStart: `${headerHeight}px`,
        marginBlockEnd: `${hbarHeight}px`,
      }}
    >
      <div className={cx(cn.content, props.variant === 'noData' && cn.textOnly)}>
        {zeroStateContent}
      </div>
    </div>
  );
};
